import { render, staticRenderFns } from "./DocumentDialog.vue?vue&type=template&id=c48edd7e&scoped=true&"
import script from "./DocumentDialog.vue?vue&type=script&lang=js&"
export * from "./DocumentDialog.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDialog.vue?vue&type=style&index=0&id=c48edd7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48edd7e",
  null
  
)

export default component.exports